import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_AGENTOPIA_SUPABASE_URL;
const anonKey = import.meta.env.VITE_AGENTOPIA_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    'Agentopia web requires VITE_AGENTOPIA_SUPABASE_URL and VITE_AGENTOPIA_SUPABASE_ANON_KEY.',
  );
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
